import React from 'react'
import './hero.css'
import people from '../../assests/people.png';
import ai from '../../assests/Header_Ai.png';
const Hero = () => {
  return (
    <section className="gpt3__header section__padding" id='home'>
      <div className="gpt3__header-content">
        <h1 className="gradient__text">Let&apos;s Build Something amazing with GPT-3 OpenAI</h1>
        <p>Yet bed any for travelling assistance indulgence unpleasing. Not thoughts all exercise blessing. Indulgence way everything joy alteration boisterous the attachment. Party we years to order allow asked of.</p>

        <div className="gpt3__header-content__input">
          <input type="email" name="email" id="email" placeholder='shoane@hotmail.com'/>
          <button type='button'>Get Started</button>
        </div>
        <div className="gpt3__header-content__people">
          <img src={people} alt="users" />
          <p>1,600 people requested access to visit in the last 24 hours</p>
        </div>
      </div>        
      <div className="gpt3__header-image"> 
        <img src={ai} alt="ai" />
      </div>
    </section>
  )
}

export default Hero